import { useApiGetSchoolList } from 'api/kinerja/kepala-sekolah/pengawas-sekolah/pelaksanaan/school'

import type { KinerjaTipe } from 'types/kinerja'

const usePenilaianCountPs = ({
  enabled = false,
  tipe,
}: {
  tipe: KinerjaTipe
  enabled: boolean
}) => {
  const {
    data: { meta: counterKs } = {},
    isLoading: isLodingCountKs,
    isFetched: isFetchedKs,
  } = useApiGetSchoolList(
    { page: 1, pageSize: 1, role: 'KS', tipe },
    { enabled }
  )

  const {
    data: { meta: counterGuru } = {},
    isLoading: isLodingCountGuru,
    isFetched: isFetchedGuru,
  } = useApiGetSchoolList(
    { page: 1, pageSize: 1, role: 'GURU', tipe },
    { enabled }
  )

  return {
    isLoading: isLodingCountKs || isLodingCountGuru,
    isSuccess: isFetchedKs || isFetchedGuru,
    data: {
      finish:
        parseInt(`${counterKs?.counts?.allCompleted || 0}`, 10) +
        parseInt(`${counterGuru?.counts?.allCompleted || 0}`, 10),
      all:
        parseInt(`${counterKs?.counts?.all || 0}`, 10) +
        parseInt(`${counterGuru?.counts?.all || 0}`, 10),
    },
  }
}

export default usePenilaianCountPs
